import { dynamicLoader } from '~/utils';

export const SaveButton = dynamicLoader({
  name: 'SaveButton',
  importFunc: () => import('./save-button'),
});